export const LAYOUTS = {
  NAME: 'layout',
  NAMESPACE: (name) => `layout/${name}`,
  CLEAR: 'CLEAR',
  SET_IS_VERTICAL_SCREEN: 'SET_IS_VERTICAL_SCREEN',
  GET_IS_VERTICAL_SCREEN: 'GET_IS_VERTICAL_SCREEN',
  SET_LAYOUT_DIMENSION: 'SET_LAYOUT_DIMENSION',
  GET_LAYOUT_DIMENSION: 'GET_LAYOUT_DIMENSION',
  GET_NAVBAR_HEIGHT: 'GET_NAVBAR_HEIGHT',
  GET_CONTENT_HEIGHT: 'GET_CONTENT_HEIGHT',
  GET_STATUSBAR_HEIGHT: 'GET_STATUSBAR_HEIGHT',
}

// mutations || actions
export const state = {
  verticalMode: false,
  navbarHeight: 0,
  contentHeight: 0,
  statusbarHeight: 0,
}

export const mutations = {
  [LAYOUTS.SET_IS_VERTICAL_SCREEN](state, bool) {
    state.verticalMode = bool
  },
  [LAYOUTS.SET_LAYOUT_DIMENSION](state, { navbarHeight, contentHeight, statusbarHeight }) {
    state.navbarHeight = navbarHeight || state.navbarHeight
    state.contentHeight = contentHeight || state.contentHeight
    state.statusbarHeight = statusbarHeight || state.statusbarHeight
  },
}

export const getters = {
  [LAYOUTS.GET_LAYOUT_DIMENSION](state) {
    return { ...state }
  },
  [LAYOUTS.GET_NAVBAR_HEIGHT](state) {
    return state.navbarHeight
  },
  [LAYOUTS.GET_CONTENT_HEIGHT](state) {
    return state.contentHeight
  },
  [LAYOUTS.GET_STATUSBAR_HEIGHT](state) {
    return state.statusbarHeight
  },
  [LAYOUTS.GET_IS_VERTICAL_SCREEN](state) {
    return state.verticalMode
  },
}

export const actions = {}
